module.exports = __webpack_public_path__ + "static/media/website-designsteins.80d9276b.png";